import ScalarIconFileDashed_vue_vue_type_script_setup_true_lang_default from "./ScalarIconFileDashed.vue.script.js";
//#region src/components/ScalarIconFileDashed.vue
var ScalarIconFileDashed_default = ScalarIconFileDashed_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarIconFileDashed_default as default };

//# sourceMappingURL=ScalarIconFileDashed.js.map